module.exports = __webpack_public_path__ + "static/media/linkimg3.1e654a47.jpg";